import $ from 'jquery'

class ApiAnimation {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		if (window.innerWidth > 992) {
			myObj.ApiAnimationFunction()
		} else {
			myObj.mobileScript()
		}
	}

	//? 3. methods (functions)
	ApiAnimationFunction() {
		let apiTL = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		apiTL
			.add('start', 0)
			.add('middle', 5)
			// .from('.title', 3, { y: 100, opacity: 0 }, 'start')
			.to('#myVideo', 1.5, { opacity: 0 })
			// .from('.copy-container', 3, { y: 100, opacity: 0 }, 'start')
			.to('.copy-container', 3, { y: -300, opacity: 0 })

			.from('.featuredimg', 1, { scale: 0.5, y: 100, opacity: 0 })
			.to('.title', 3, { y: -300, opacity: 0 })
			.staggerFrom('.animateRow', 3, { y: 500, opacity: 0 }, 0.3)
			.to('.featuredimg', 1, { opacity: 1 })

		var termynal = new Termynal('.myTerm', { noInit: true })
		let mytrigger = false
		// // init controller
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#point',
			offset: window.innerHeight / 2,
			duration: window.innerHeight * 3,
		})
			.setTween(apiTL) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' })
			.setPin('#point')
			.addTo(controller)

		var Typescene = new ScrollMagic.Scene({
			triggerElement: '.myTerm',
			offset: 150,
		})
			.addTo(controller)
			// .addIndicators() // add indicators (requires plugin)

			.on('enter leave', function (e) {
				if (!mytrigger) {
					termynal.init()
					mytrigger = true
				}
			})
		// .on("start end", function (e) {
		// 	termynal.init()
		// })
	}
	mobileScript() {
		var termynal = new Termynal('.myTermTwo', { noInit: true })
		let mytrigger = false

		var controller = new ScrollMagic.Controller()

		var Typescene = new ScrollMagic.Scene({
			triggerElement: '#thisIsATigger',
			offset: -window.innerHeight / 2,
		})
			.addTo(controller)
			// .addIndicators() // add indicators (requires plugin)
			.on('enter leave', function (e) {
				console.log('trigger is hit')
				if (!mytrigger) {
					termynal.init()
					mytrigger = true
				}
			})
	}
}

export default ApiAnimation
